import React from "react";
import classNames from "classnames";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { Bet } from "@models";
import { ISOToDisplayCode } from "@utils";
import { useRootAppStore } from "@hooks";
import { THEME_SETTINGS } from "@theme-settings";

export default observer(function MyBetsAutosellButton(props: {
	bet: Bet;
	openAutosellModal: (bet: Bet) => void;
}) {
	const { t } = useTranslation("mybets");

	const rootStore = useRootAppStore();

	if (!WEBPACK_IS_AUTOCASHOUT_ENABLED) {
		return null;
	}

	const autoCashoutButtonClasses = classNames(
		"card--bet__btn card--bet__btn--auto btn btn--sml btn--block btn--primary--subtle btn--icon u-mar--top--tny",
		{
			"card--bet__btn--auto-set": props.bet.isAutoCashoutSet
				? true
				: false,
		}
	);

	const autoCashoutIconClasses = classNames("u-icon u-icon--sml", {
		"u-icon--settings": !props.bet.isAutoCashoutSet,
		"u-icon--set-stake": props.bet.isAutoCashoutSet,
	});

	const isButtonDisabled =
		rootStore.myBetsViewStore.cashoutStore.isCashoutFormSubmitting;

	if (
		props.bet.displayedAmount == null ||
		props.bet.displayedAmount == "0.00"
	) {
		return null;
	}

	if (
		WEBPACK_IS_AUTOCASHOUT_ENABLED &&
		props.bet.displayedAmount !== undefined &&
		props.bet.displayedAmount !== null &&
		props.bet.displayedAmount !== "0.00"
	) {
		return (
			<button
				className={autoCashoutButtonClasses}
				type="button"
				onClick={() => props.openAutosellModal(props.bet)}
				disabled={isButtonDisabled}
			>
				<i className={autoCashoutIconClasses} />
				<span>
					{t("CASHOUT.AUTO_CASHOUT")}{" "}
					{props.bet.isAutoCashoutSet &&
					props.bet.betSlipSecureWinSetting != null
						? `${props.bet.betSlipSecureWinSetting.threshold.toFixed(
								2
							)} ${ISOToDisplayCode(
								THEME_SETTINGS.defaultCurrency
							)}`
						: ""}
				</span>
			</button>
		);
	} else {
		return null;
	}
});
